/* eslint-disable camelcase */
const getCustomerNameByCode = (customers, code) => { var _a; return ((_a = customers === null || customers === void 0 ? void 0 : customers.find(c => c.code === code)) === null || _a === void 0 ? void 0 : _a.company_name) || code; };
export default getCustomerNameByCode;
